import { Box } from "@mui/material";
import { useContext, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { InquiryCode, Prefectures } from "../../assets/data/Constants";
import { labelids } from "../../assets/data/TkExplanationProperty";
import TkInfoManual from "../../components/atoms/TkInfoManual";
import TkBackButton from "../../components/molecules/TkBackButton";
import TkDataTable from "../../components/molecules/TkDataTable";
import TkKikoStepper from "../../components/molecules/TkKikoStepper";
import TkMemo from "../../components/molecules/TkMemo";
import TkViewButtonJudgement from "../../components/molecules/TkViewButtonJudgement";
import { BusinessContext } from "../../context/businessContext";
import { GlobalContext } from "../../context/globalContext";
import { IAPI_APP016_Request } from "../../type/apiType";
import { ITkViewButtonJudgementStatus } from "../../type/componentsType/TkViewButtonJudgement";
import { TkGetCode } from "../../utils/TkGetCode";
import "./_style.scss";
import { httpIAPI_APP016, httpIAPI_FAC001 } from "./api/request";
import {
  fakeTableList,
  infoHeadTitleList,
  infoHeadTitleMemoList,
} from "./parts";
import TkContractorAndNumberLine from "../../components/molecules/TkContractorAndNumberLine";
import _ from "lodash";
import TkFakeTable from "../../components/molecules/TkFakeTable";
import TkRadio from "../../components/atoms/TkRadio";

/**
 * SCRW050007 非加入の取下げ登録
 * @return SCRW050007
 */
const SCRW050007 = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [statusInfoTableList, setStatusInfoTableList] = useState<any>({
    infoHeadTitleList: infoHeadTitleMemoList,
    infoBodyList: [],
  });
  const [bodyList, setBodyList] = useState<any>([]);
  const [memo, setMemo] = useState<string>("");
  const [isApplyCodeChecked, setIsApplyCodeChecked] = useState<string>("");
  const [statusCd, setStatusCd] = useState<ITkViewButtonJudgementStatus>(); // TODO 課題584
  const { state, setState } = useContext(GlobalContext);
  const { state: businessState } = useContext(BusinessContext);
  const contractorNo = businessState.common?.contractorNo;
  const [corpApplyKbn, setCorpApplyKbn] = useState<"1" | "other" | undefined>();
  const [stateInfoList, setStateInfoList] = useState<any>([]);
  const stateFakeTableList = useRef(_.cloneDeep(fakeTableList));

  // 初期化
  const handleInit = async () => {
    try {
      const res = await httpIAPI_FAC001({
        contractorNo: contractorNo!,
        applyId: location?.state?.applyId,
      });

      const facilityList: any = [];
      if (res?.resultCd === "I0000") {
        // setStatusCd(res?.)
        const memoList: any = [];
        (res?.statusList ?? []).forEach((memo) => {
          const data = [
            {
              children: memo.managerName,
            },
            {
              children: memo.process,
            },
            {
              children: memo.createDate,
            },
            {
              children: memo.processComment,
            },
          ];
          memoList.push(data);
        });
        setStatusInfoTableList({
          infoHeadTitleList: infoHeadTitleMemoList,
          infoBodyList: memoList,
        });

        res?.facilityList?.forEach((item, index) => {
          const prefectureName = TkGetCode(
            Prefectures,
            item.facilityPrefectureCd
          );
          const list = [
            {
              children: (
                <Box className="TkRadioInSCRW050007">
                  <TkRadio checked={true} disabled={true} />
                </Box>
              ),
              width: "60px",
            },
            {
              children: `${item.facilityNo}:${item.facilityName}`,
              forSort: item.facilityNo,
              width: 150,
              disabledCheckBox: true,
            },
            {
              children: item.facilityKind,
              forSort: item.facilityKind,
              width: 200,
            },
            {
              children: `${prefectureName}${item.facilityAddressCity ?? ""}${
                item.facilityAddressOthers ?? ""
              }`,
              forSort: `${prefectureName}${item.facilityAddressCity}${item.facilityAddressOthers}`,
              width: 250,
            },
            {
              children: item.contractStatusName,
              forSort: item.contractStatusName,
              width: 150,
            },
          ];
          facilityList.push(list);
        });
        let resArr = stateFakeTableList.current;
        resArr.find((i) => i.keyword === "cancelDate")!.setDefaultValue =
          res.joinDate;
        setStateInfoList([...resArr]);
        setBodyList(facilityList);
        setStatusCd(res?.latestApplyStatus as ITkViewButtonJudgementStatus); // TODO 課題584
        setCorpApplyKbn(res?.corpApplyKbn as "1" | "other" | undefined);
        setState({
          ...state,
          errorMsgId: "",
        });
      } else {
        setState({
          ...state,
          errorMsgId: res?.resultCd,
        });
      }
    } catch {
      navigate("/error");
    }
  };

  // 初期化
  useEffect(() => {
    handleInit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const makeHttpObj = (item: string): IAPI_APP016_Request => {
    const reqObj: IAPI_APP016_Request = {
      applyId: location?.state?.applyId,
      applyEvent: item,
      contractorNo: businessState.common?.contractorNo,
      reason: memo,
      inquiryCode: isApplyCodeChecked ? InquiryCode["施設"] : undefined,
      screenId: "SCRW050007",
    };

    return reqObj;
  };

  const onCheckAndSubmit = (item: string) => {
    if (!memo.match(/^[^ -~｡-ﾟ]+$/) && memo !== "") {
      return;
    }
    if (item === "受理") {
      handleSubmit("2");
    } else if (item === "契約者に差戻し") {
      handleSubmit("5");
    } else if (item === "課長代理確認") {
      handleSubmit("14");
    } else if (item === "担当者に差戻し") {
      handleSubmit("8");
    } else if (item === "上長承認") {
      handleSubmit("6");
    }
  };

  const handleSubmit = async (item: string) => {
    try {
      const res = await httpIAPI_APP016({
        ...makeHttpObj(item),
      });

      if (res?.resultCd === "I0000") {
        setState({
          ...state,
          errorMsgId: "",
        });
        navigate("/SCRW110001");
      } else {
        setState({
          ...state,
          errorMsgId: res?.resultCd,
        });
      }
    } catch {
      navigate("/error");
    }
  };

  // メモ、チェックボックス入力値変更
  const handleChangeData = (data: any) => {
    if (data?.target?.type === "input") {
      setMemo(data?.target?.value);
    } else {
      setIsApplyCodeChecked(data?.target?.value);
    }
  };

  return (
    <Box className="SCRW050007" data-testid="SCRW050007PageForTest">
      <TkKikoStepper
        applicationFlowType={"TYPE3"}
        businessType={"JOB-22"}
        corporateApplicationClassification={corpApplyKbn}
        applicationStatus={statusCd}
      />
      <TkInfoManual rule={"\\n"}>{labelids.labelid.LBLW050007_01}</TkInfoManual>
      <TkContractorAndNumberLine
        name="契約者（法人）名"
        no={
          (businessState?.common?.contractorNo ?? "") +
          ":" +
          (businessState?.common?.contractorName ?? "")
        }
      />
      <TkFakeTable list={stateInfoList} ruleSchema={{}} showButton={false} />
      <TkDataTable bodyList={bodyList} headList={infoHeadTitleList} />
      {/* メモ、コメント、チェックボックス */}
      <TkMemo
        headList={statusInfoTableList.infoHeadTitleList}
        bodyList={statusInfoTableList.infoBodyList}
        onChange={handleChangeData}
        disabledCheckBox={false}
      />
      <Box className="btn">
        <TkBackButton mr />
        <TkViewButtonJudgement
          flowType={"TYPE3"}
          Status={statusCd}
          onClick={onCheckAndSubmit}
        />
      </Box>
    </Box>
  );
};

export default SCRW050007;
